{
  "title": "Wall of Force",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level evocation",
  "level": 5,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S, M (a pinch of powder made by crushing a clear gemstone)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "An invisible wall of force springs into existence at a point you choose within range.",
    "The wall appears in any orientation you choose, as a horizontal or vertical barrier or at an angle. It can be free floating or resting on a solid surface. You can form it into a hemispherical dome or a sphere with a radius of up to 10 feet, or you can shape a flat surface made up of ten 10-foot-by-10-foot panels. Each panel must be contiguous with another panel. In any form, the wall is 1/4 inch thick. It lasts for the duration. If the wall cuts through a creature's space when it appears, the creature is pushed to one side of the wall (your choice which side).",
    "Nothing can physically pass through the wall. It is immune to all damage and can't be dispelled by dispel magic. A disintegrate spell destroys the wall instantly, however. The wall also extends into the Ethereal Plane, blocking ethereal travel through the wall."
  ],
  "spellLists": ["wizard"]
}
